import { Suspense } from "react";
import { SectionHero, SectionRichText, SectionImageText, SectionCtaBand, SectionFeatureGrid, SectionGallery, SectionCarouselBanner } from "@/components/sections/sections";
import { WIDGETS } from "@/components/sections/widgetRegistry";

const MAP = {
  hero: SectionHero,
  rich_text: SectionRichText,
  image_text: SectionImageText,
  cta_band: SectionCtaBand,
  feature_grid: SectionFeatureGrid,
  gallery: SectionGallery,
  carousel_banner: SectionCarouselBanner,
};

// Renders one section. `preview` forces visibility (used by the editor preview).
export const SectionRenderer = ({ section, preview = false }) => {
  if (!section) return null;
  if (!preview && section.visible === false) return null;
  let inner = null;
  if (section.type === "embed") {
    const W = WIDGETS[section.widget];
    if (!W) return null;
    inner = <Suspense fallback={null}><W content={section.content || {}} /></Suspense>;
  } else {
    const C = MAP[section.type];
    inner = C ? <C section={section} /> : null;
  }
  if (!inner) return null;
  // Wrap in an anchor container so admin-defined #links resolve on every section type.
  const anchor = (section.anchor || "").trim();
  return anchor ? <div id={anchor} className="scroll-mt-24">{inner}</div> : inner;
};
